
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 94 94","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M49.383 18.696a2.25 2.25 0 0 1 2.08-1.392c3.213 0 6.301 1.255 8.584 3.501a11.92 11.92 0 0 1 3.57 8.605L63.08 40.7h16.318a8.946 8.946 0 0 1 3.7.762 8.847 8.847 0 0 1 3.056 2.233A8.72 8.72 0 0 1 87.983 47a8.65 8.65 0 0 1 .257 3.746l-3.905 28.578-.005.038a8.723 8.723 0 0 1-3.033 5.36 8.919 8.919 0 0 1-5.807 2.072H28.35a8.909 8.909 0 0 1-6.248-2.55 8.697 8.697 0 0 1-2.606-6.2V54.65c0-2.332.942-4.561 2.606-6.2a8.909 8.909 0 0 1 6.248-2.55h9.819l11.215-27.203Z","fill":"#D0EFEC"}}),_c('path',{attrs:{"d":"m32.554 41.047 12.41-30.1c2.765 0 5.417 1.08 7.373 3.005a10.18 10.18 0 0 1 3.053 7.256l-.684 14.367H74.38a7.047 7.047 0 0 1 2.925.599 6.945 6.945 0 0 1 2.4 1.752 6.811 6.811 0 0 1 1.43 2.582c.28.952.348 1.953.196 2.934l-4.112 30.1a6.814 6.814 0 0 1-2.37 4.187 7.02 7.02 0 0 1-4.581 1.629H20.633a7.008 7.008 0 0 1-4.915-2.004 6.786 6.786 0 0 1-2.036-4.838V47.89c0-1.815.732-3.555 2.036-4.838a7.008 7.008 0 0 1 4.915-2.004h11.92Zm0 0H30.1v38.311","stroke":"#234652","stroke-width":"2.791","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    